import BaseService from '../base-service';
import NetworkUrls from '../network-urls';

class CountriesService extends BaseService {
  async fetch() {
    const config = {
      url: NetworkUrls.graphql,
      method: 'POST',
      data: {
        query: `query {
          Countries {
            id,
            name,
            name_en
          }
        }`,
      },
    };

    return this._exec(config);
  }
}

export const countriesService = new CountriesService();



// WEBPACK FOOTER //
// ./src/network/services/countries.service.js